var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bean-source-page',{attrs:{"type":_vm.type,"columns":_vm.columns,"form-columns":_vm.formColumns,"filter-columns":_vm.filterColumns,"form":_vm.form,"title":_vm.$t('model.riskAssessmentResult'),"resource":"risk_assessment_results"}})}
var staticRenderFns = []

export { render, staticRenderFns }